import BaseSelectWithLoadMore from './BaseSelectWithLoadMore.vue';

export default BaseSelectWithLoadMore;
export { BaseSelectWithLoadMore };
